'use client';

import type { NextLayoutProps } from '@/types';

import React from 'react';
import { ArrowRight } from 'react-feather';
import { useRouter } from 'next/navigation';

import { Box, Button, Icon, Link, Stack } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';
import LiaTeamLogo from '@/svgs/lia-logo-vertical.svg';

export default function AuthLayout({
  children,
}: NextLayoutProps): React.ReactElement {
  const { t } = useTranslation('pages.auth');
  const router = useRouter();
  return (
    <Stack minH="100dvh" flexDir="column" position="relative">
      <Box
        w="50%"
        h="full"
        bg="secondary.50"
        position="absolute"
        left={0}
        top={0}
      />
      <Stack
        w="full"
        h="full"
        minH="100dvh"
        align="center"
        pt={10}
        px={2.5}
        gap="25px"
        zIndex="docked"
      >
        <Button
          as={Link}
          variant="link"
          textDecoration="none"
          href={routes.home.url}
          leftIcon={<Icon boxSize="6" as={ArrowRight} stroke={'text'} />}
          onClick={() => {
            router.push(routes.home.url);
          }}
        >
          {t('returnToMainPage')}
        </Button>
        <Stack
          flex={1}
          align="center"
          justify="center"
          w="100%"
          h="100%"
          px={{ base: 8, md: 12 }}
          pt={{ base: 8, md: 12 }}
          pb={6}
          shadow="elevated4"
          bg="white"
          mb={{ base: '60px', md: '44px' }}
          maxW="608px"
          borderRadius="3xl"
        >
          <Stack
            w={{ base: '110px', md: '160px' }}
            mb={{ base: '22px', md: '60px' }}
          >
            <Link href={routes.home.url}>
              <LiaTeamLogo />
            </Link>
          </Stack>
          {children}
        </Stack>
      </Stack>
    </Stack>
  );
}
